import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background: var(--nd-surface);
  border: 1px solid var(--nd-border);
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  text-decoration: none !important;
  color: inherit !important;
  transition: border-color 250ms cubic-bezier(0.25, 0.1, 0.25, 1);
  &:hover { border-color: var(--nd-border-visible); }
`;

const Kicker = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin-bottom: 12px;
`;

const Title = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: var(--nd-text-display);
  line-height: 1.25;
  letter-spacing: -0.01em;
  margin: 0 0 4px;
`;

const ClientHint = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 12px;
  color: var(--nd-text-secondary);
  letter-spacing: 0.04em;
  margin: 0 0 16px;
`;

const Desc = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0 0 16px;
  flex-grow: 1;
`;

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
`;

const Chip = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nd-text-primary);
  border: 1px solid var(--nd-border-visible);
  padding: 4px 8px;
  border-radius: 999px;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid var(--nd-border);
`;

const Duration = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  color: var(--nd-text-secondary);
  letter-spacing: 0.04em;
`;

const ViewLink = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-display);
`;

const truncate = (s, n) => (s && s.length > n ? `${s.slice(0, n).trim()}…` : s);

const OpeningCard = ({ opening }) => (
  <Card
    to={`/team/openings/${opening.slug}/`}
    aria-label={`Open position: ${opening.title} for ${opening.clientHint}`}
  >
    <Kicker>{opening.kicker}</Kicker>
    <Title>{opening.title}</Title>
    <ClientHint>{opening.clientHint}</ClientHint>
    <Desc>{truncate(opening.description, 160)}</Desc>
    <ChipRow>
      <Chip>{opening.location}</Chip>
      {(opening.techStack || []).slice(0, 3).map((t) => (
        <Chip key={t}>{t}</Chip>
      ))}
    </ChipRow>
    <Footer>
      <Duration>{opening.durationMonths} mo</Duration>
      <ViewLink>View opening →</ViewLink>
    </Footer>
  </Card>
);

export default OpeningCard;
